import { Check } from 'lucide-react';

export const TrustSection = () => (
<section className="py-8 md:py-12 bg-gradient-to-b from-black to-gray-950">
        <div className="container mx-auto px-4">
          <div className="max-w-6xl mx-auto">
            <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6">
              <div className="text-center p-4">
                <Check className="w-10 h-10 md:w-12 md:h-12 text-green-500 mx-auto mb-3" />
                <p className="text-white font-semibold text-sm md:text-base">Sorcier Vaudou Authentique</p>
              </div>
              <div className="text-center p-4">
                <Check className="w-10 h-10 md:w-12 md:h-12 text-green-500 mx-auto mb-3" />
                <p className="text-white font-semibold text-sm md:text-base">Rituels Garantis</p>
              </div>
              <div className="text-center p-4">
                <Check className="w-10 h-10 md:w-12 md:h-12 text-green-500 mx-auto mb-3" />
                <p className="text-white font-semibold text-sm md:text-base">Discrétion Absolue</p>
              </div>
              <div className="text-center p-4">
                <Check className="w-10 h-10 md:w-12 md:h-12 text-green-500 mx-auto mb-3" />
                <p className="text-white font-semibold text-sm md:text-base">Disponible 7j/7</p>
              </div>
            </div>
          </div>
        </div>
      </section>
);
